enum JobWorkerInterviewWorkerDeclinedReason {
    Undefined = 0,
    Unavailable = 1,
    NoLongerInterested = 2,
}

export default JobWorkerInterviewWorkerDeclinedReason;